import styled from "styled-components";

export const WrapperInner = styled.div`
.filters{
.ant-select-selector, .ant-input-number-outlined {
    background: #fff !important;
    color: #5E6278 !important;
    // border-color: #fff !important;   
     min-height: 42px;
}
.ant-input-number .ant-input-number-input{
    padding: 9px 11px;
}
.ant-select-selection-item{
    font-size: 13px !important;
    font-weight: 500;
}
.ant-select-item{
font-size: .95rem !important;
    font-weight: 500;
}
    .ant-select .ant-select-arrow{
        height: 22px;
    }
.ant-select .ant-select-selection-placeholder{
font-size: 13px !important;
    color: #5E6278 !important;
    font-weight: 500;
}
.ant-picker-input input{font-size:13px}
.ant-picker-range {
    border:1px solid #fff;
}
.ant-select-item-option-content{
 font-size: .9rem !important;
}

.ant-select-multiple .ant-select-selection-item-content{
    font-size: 12px;
}
}

.add-alert{
.ant-select-selector, .ant-input-number-outlined {
    background: #F4F4F4 !important;
    color: #5E6278 !important;
    border-color: #F4F4F4 !important;    min-height: 42px;
}
.ant-input-number .ant-input-number-input{
    padding: 9px 11px;
}
.ant-select-selection-item{
    font-size: 13px !important;
    font-weight: 500;
}
.ant-select-item{
font-size: .95rem !important;
    font-weight: 500;
}
    .ant-select .ant-select-arrow{
        height: 22px;
    }
.ant-select .ant-select-selection-placeholder{
font-size: 13px !important;
    color: #5E6278 !important;
    font-weight: 500;
}
.ant-picker-input input{font-size:13px}
.ant-picker-range {
    border:1px solid #fff;
}

.ant-select-multiple .ant-select-selection-item-content{
    font-size: 12px;
    }

.ant-select-dropdown .ant-select-item{
    font-size: 12px;
}
}
    .alert-read-row {
        background-color: #f5f5f5 !important;
        opacity: 0.6;
    }

    .ant-table-row.alert-read-row {
        background-color: #f5f5f5 !important;
        opacity: 0.6;
    }

    .text-two {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* white-space: pre-wrap; */
    width: 250px;
    margin-bottom: 0 !important;
  }
`;